export const UrlCollection = {
    Home: '/',
    Login: 'login',

    Dashboard: '/dashboard',

    Parameter: '/parameter',
    CreateParameter: '/parameter/create',
    EditParameter: '/parameter/:id',

    Standard: '/standard',
    CreateStandard: '/standard/create',
    EditStandard: '/standard/edit/:id',
    ViewStandard: '/standard/:id',

    Station: '/station',
    CreateStation: '/station/create',
    EditStation: '/station/edit/:id',
    ViewStation: '/station/:id',

    SamplingSchedule: '/sampling-schedule/:stationId',
    CreateSamplingSchedule: '/sampling-schedule/:stationId/create',
    EditSamplingSchedule: '/sampling-schedule/:stationId/edit/:id',

    Problem: '/problem',
    CreateProblem: '/problem/create',
    EditProblem: '/problem/edit/:id',
    ViewProblem: '/problem/:id',

    Statistic: '/statistic',
    StatisticData: '/statistic/data',
    StatisticMinMaxData: '/statistic/min-max-data',
    StatisticNumberOfTimesExceededData: '/statistic/number-of-times-exceeded-data',
    StatisticThresholdExceedanceData: '/statistic/threshold-exceedance-data',

    WaterMonitoring: '/water-monitoring',

    Map: '/map',

    UserInfo: '/user-info',

    Adminstrator: '/adminstrator',
    UserManager: '/adminstrator/user-manager',

    CreateUser: '/adminstrator/user-manager/create',
    EditUser: '/adminstrator/user-manager/edit/:id',

    Roles: '/adminstrator/roles',
    CreateRole: '/adminstrator/roles/create',
    EditRole: '/adminstrator/roles/edit/:id',

    ParameterUnit: '/adminstrator/unit',
    CreateParameterUnit: '/adminstrator/unit/create',
    EditParameterUnit: '/adminstrator/unit/:id',

    Register2FA: '/register2fa'
}